import React, { Component } from "react";
import { ButtonGroup } from "reactstrap";
import DeleteDocument from "./DeleteDocument";
import EditDocument from "./EditDocument";

class DocumentActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documents: []
    };
  }

  handleDownload = async () => {
    const { file, name } = this.props.row;

    try {
      const response = await fetch(file);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed", error);
    }
  };

  render(){
    const { row } = this.props;
    
    return (
      <ButtonGroup>          
          <a
            className='btn btn-primary'
            onClick={() => window.open(row.file, '_blank')}
          >
            <i className='fa fa-eye' />
          </a>
          <a
            className='btn btn-primary'
            onClick={this.handleDownload} 
          >
            <i className={'fa fa-download'}> </i>
          </a>
          <DeleteDocument documentId={row.id}/>
      </ButtonGroup>
    );
  }
}

export function getDocumentsListColumns({
  handleSave
}) {
  return [
    {
        text: 'Name',
        dataField: 'name',
        headerClasses: 'text-left align-middle',
        classes: 'text-left align-middle overflow-hidden text-truncate'
    },
    {
        text: 'Typ',
        dataField: 'type_name',
        headerClasses: 'text-left align-middle',
        classes: 'text-left align-middle',
        // formatter: (cell, row) => <EditDocument row={row} handleSave={handleSave}/>
    },
    {
      text: 'Erstellt am',
      dataField: 'created_at',
      headerClasses: 'text-left align-middle',
      classes: 'text-left align-middle',
      formatter: function DateFormatter(cell, row) {
        return new Date(cell).toLocaleDateString('de-DE', {
          year: "numeric",
          month: "long",
          day: "numeric"
        })
      }
    },
    {
      dataField: 'id',
      text: '',
      isDummyField: true,
      formatter: (cell, row) => <DocumentActions row={row} />
    }
  ]
}
